var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 75,
    viewBox: "0 0 55 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.068L0.445735 59.4312L21.7561 18.9966L21.7986 18.5721L12.4169 0.93375C11.6316 -0.552035 9.42412 -0.169976 9.14819 1.48561L0 60.068Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.275939 59.5799L0.615547 58.9219L21.7137 18.9119L12.332 1.18859C11.5467 -0.275966 9.5727 0.106093 9.318 1.74046L0.275939 59.5799Z",
    fill: "#FFA712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.275939 59.5799L0.615547 58.9219L21.7137 18.9119L12.332 1.18859C11.5467 -0.275966 9.5727 0.106093 9.318 1.74046L0.275939 59.5799Z",
    fill: "#F6820C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6544 31.9231L35.6588 24.7489L28.6544 11.3981C27.9964 10.1246 26.1286 10.1246 25.4706 11.3981L21.7349 18.5299V19.1454L28.6544 31.9231Z",
    fill: "#F4BD62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5271 31.6259L35.3192 24.664L28.5271 11.7164C27.8903 10.4853 26.3196 10.358 25.6829 11.5891L21.9259 18.827L21.8198 19.1878L28.5271 31.6259Z",
    fill: "#FFA50E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5271 31.6259L35.3192 24.664L28.5271 11.7164C27.8903 10.4853 26.3196 10.358 25.6829 11.5891L21.9259 18.827L21.8198 19.1878L28.5271 31.6259Z",
    fill: "#F6820C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.068L0.212269 59.8558L0.955162 59.5586L28.2087 32.39L28.5695 31.4561L21.7561 18.4873L0 60.068Z",
    fill: "#DD700E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5247 73.7798L54.2099 60.0257L47.1631 16.5983C46.9508 15.2399 45.274 14.7093 44.2976 15.6856L0 60.068L24.5367 73.7586C26.0861 74.6288 27.9752 74.6288 29.5247 73.7798Z",
    fill: "#FDE068"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9977 59.8983L46.9932 16.8318C46.781 15.4946 45.3801 14.9215 44.425 15.8978L0.275939 59.9832L24.5367 73.5463C26.0861 74.3953 27.954 74.4165 29.4822 73.5463L53.9977 59.8983Z",
    fill: "#FCCA3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5247 73.3553C27.9752 74.2255 26.0861 74.2255 24.5367 73.3553L0.191044 59.8559L0 60.068L24.5367 73.7586C26.0861 74.6288 27.9752 74.6288 29.5247 73.7586L54.2099 60.0044L54.1462 59.6224L29.5247 73.3553Z",
    fill: "#EEAB37"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.01039e-06 0H54.3373V74.5015H1.01039e-06V0Z",
    style: {
      mixBlendMode: "saturation"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebaseIcon);
export default __webpack_public_path__ + "static/media/firebase-icon.c61111fb228fb6ba7512710ee4d3077c.svg";
export { ForwardRef as ReactComponent };